import './style.css';
import * as THREE from 'three';
import * as THREE_ADDONS from 'three-addons';
import GUI from 'lil-gui';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { BoxLineGeometry } from 'three-addons';
import { VRButton } from 'three/examples/jsm/webxr/VRButton.js';

import * as FOUR from './four/Four.js';

const myHyperCube = new FOUR.HyperCube(4);

/* 
Debug
*/
const gui = new GUI({ width: 500 });
gui.hide();

window.addEventListener('keydown', (event) => {
  if (event.key === 'h') {
    if (gui._hidden) gui.show();
    else gui.hide();
  }
});

// Tranform Hypercube to 3 dimensions
let projected3d = [];

const geometry = new THREE.BufferGeometry();
const positions = new Float32Array(myHyperCube.points.length * 3);

// Rotations
let transform4D = {
  scale: 1,
  angleXY: 0,
  angleXZ: 0,
  angleXW: 0,
  angleYZ: 0,
  angleYW: 0,
  angleZW: 0,
};

// Debug
gui.add(transform4D, 'scale').min(0.01).max(3).step(0.01).name('Scale');
gui
  .add(transform4D, 'angleXY')
  .min(-Math.PI)
  .max(Math.PI)
  .step(0.01)
  .name('Rotate XY');
gui
  .add(transform4D, 'angleXZ')
  .min(-Math.PI)
  .max(Math.PI)
  .step(0.01)
  .name('Rotate XZ');
gui
  .add(transform4D, 'angleXW')
  .min(-Math.PI)
  .max(Math.PI)
  .step(0.01)
  .name('Rotate XW');
gui
  .add(transform4D, 'angleYZ')
  .min(-Math.PI)
  .max(Math.PI)
  .step(0.01)
  .name('Rotate YZ');
gui
  .add(transform4D, 'angleYW')
  .min(-Math.PI)
  .max(Math.PI)
  .step(0.01)
  .name('Rotate YW');
gui
  .add(transform4D, 'angleZW')
  .min(-Math.PI)
  .max(Math.PI)
  .step(0.01)
  .name('Rotate ZW');

for (let i = 0; i < myHyperCube.points.length; i++) {
  let transformed = myHyperCube.points[i];

  let r = 3; // Distance to origin from viewpoint
  let f = 2; // Distance from origin to projection plane

  let w = r - f / (r - transformed[3]);

  const projection = [
    [w, 0, 0, 0],
    [0, w, 0, 0],
    [0, 0, w, 0],
  ];

  // let projected = matmul(projection, transformed);
  let newX = ((r - f) * transformed[0]) / (r - transformed[3]);
  let newY = ((r - f) * transformed[1]) / (r - transformed[3]);
  let newZ = ((r - f) * transformed[2]) / (r - transformed[3]);

  let projected = new FOUR.Point4D(newX, newY, newZ, 0);

  // projected.mult(width / 4);
  projected3d[i] = projected;
  positions[i * 3] = projected3d[i].x;
  positions[i * 3 + 1] = projected3d[i].y;
  positions[i * 3 + 2] = projected3d[i].z;
}

geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();

/************************/
/******** LIGHTS ********/
/************************/
const spotLight = new THREE.SpotLight(0xffcccc);
spotLight.position.set(3, 3, 3);

scene.add(spotLight);

const light = new THREE.AmbientLight(0xcefefef); // soft white light
scene.add(light);

const light2 = new THREE.DirectionalLight(0xfff0dd, 1);
light2.position.set(0, 5, 10);
scene.add(light2);

// Background Texture
const bgTexture = new THREE.TextureLoader().load('textures/kim-sooja.jpg');
// const bgGeometry = new THREE.PlaneGeometry(5, 5);
// const bgMaterial = new THREE.MeshBasicMaterial({ map: bgTexture });
// const bgMesh = new THREE.Mesh(bgGeometry, bgMaterial);
// bgMesh.position.set(0, 0, -1);
// scene.add(bgMesh);

// bgTexture = loader.load('textures/kim-sooja.jpg', function (texture) {
//   var img = texture.image;
//   bgWidth = img.width;
//   bgHeight = img.height;
//   resize();
// });
// scene.background = bgTexture;
// bgTexture.wrapS = THREE.MirroredRepeatWrapping;
// bgTexture.wrapT = THREE.MirroredRepeatWrapping;
scene.background = new THREE.Color(0x0000cc);

let fourCubeGroup = new THREE.Group();

// Add Vertices to scene
const pointsMaterial = new THREE.PointsMaterial({
  size: 1,
  sizeAttenuation: false,
});
const points = new THREE.Points(geometry, pointsMaterial);
points.geometry.attributes.position.needsUpdate = true;
fourCubeGroup.add(points);

/* Faces */
const material = new THREE.MeshPhongMaterial({
  transparent: true,
  opacity: 0.5,
  color: 0xffff00,
  // specular: 0xffff00,
  // shininess: 30,
  side: THREE.DoubleSide,
});

const materialTwo = new THREE.MeshPhongMaterial({
  transparent: true,
  opacity: 0.5,
  color: 0xffff00,
  // specular: 0xffff00,
  // shininess: 30,
  side: THREE.DoubleSide,
});

geometry.setIndex([
  0, 4, 8, 8, 4, 12, 0, 2, 8, 8, 2, 10, 0, 2, 4, 4, 2, 6, 0, 1, 8, 8, 1, 9,
]);

geometry.setIndex([
  0, 4, 8, 8, 4, 12, 0, 2, 8, 8, 2, 10, 0, 2, 4, 4, 2, 6, 0, 1, 8, 8, 1, 9, 0,
  1, 4, 4, 1, 5, 0, 1, 2, 2, 1, 3, 1, 5, 9, 9, 5, 13, 1, 3, 9, 9, 3, 11, 1, 3,
  5, 5, 3, 7, 2, 6, 10, 10, 6, 14, 2, 3, 10, 10, 3, 11, 2, 3, 6, 6, 3, 7, 3, 7,
  11, 11, 7, 15, 4, 6, 12, 12, 6, 14, 4, 5, 12, 12, 5, 13, 4, 5, 6, 6, 5, 7, 5,
  7, 13, 13, 7, 15, 6, 7, 14, 14, 7, 15, 8, 10, 12, 12, 10, 14, 8, 9, 12, 12, 9,
  13, 8, 9, 10, 10, 9, 11, 9, 11, 13, 13, 11, 15, 10, 11, 14, 14, 11, 15, 12,
  13, 14, 14, 13, 15,
]);
// 0, 4, 8, 8, 4, 12,
// 0, 2, 8, 8, 2, 10,
// 0, 2, 4, 4, 2, 6,
// 0, 1, 8,8, 1, 9,
// 0, 1, 4, 4, 1, 5,
// 0, 1, 2, 2, 1, 3,
// 1, 5, 9, 9, 5, 13,
// 1, 3, 9, 9, 3, 11,
// 1, 3, 5, 5, 3, 7,
// 2, 6, 10, 10, 6, 14,
// 2, 3, 10, 10, 3, 11,
// 2, 3, 6, 6, 3, 7,
// 3, 7, 11, 11, 7, 15,
// 4, 6, 12, 12, 6, 14,
// 4, 5, 12, 12, 5, 13,
// 4, 5, 6, 6, 5, 7,
// 5, 7, 13, 13, 7, 15,
// 6, 7, 14, 14, 7, 15,
// 8, 10, 12, 12, 10, 14,
// 8, 9, 12, 12, 9, 13,
// 8, 9, 10, 10, 9, 11,
// 9, 11, 13, 13, 11, 15,
// 10, 11, 14, 14, 11, 15,
// 12, 13, 14, 14, 13, 15,
// geometry.setIndex([0, 1, 8, 8, 1, 9]);

var materials = [
  new THREE.MeshPhysicalMaterial({
    roughness: 0,
    transmission: 0.8,
    thickness: 0,
    clearcoatRoughness: 0.4,
    // metalness: 1,
    color: 0xff00ff,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.5,
  }),
  new THREE.MeshPhysicalMaterial({
    roughness: 0.1,
    transmission: 0.8,
    thickness: 0,
    clearcoatRoughness: 0.4,
    color: 0x00ff00,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.6,
  }),
  new THREE.MeshPhysicalMaterial({
    roughness: 0.1,
    transmission: 0.8,
    thickness: 0,
    clearcoatRoughness: 0.4,
    color: 0xff0000,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.5,
  }),
];

geometry.computeVertexNormals();
const mesh = new THREE.Mesh(geometry, materials);

geometry.addGroup(0, 36, 0);
geometry.addGroup(36, 72, 1);
geometry.addGroup(72, 144, 2);

scene.add(fourCubeGroup);
fourCubeGroup.add(mesh);
/**
 * Lines
 */

const linesGeometry = new THREE.BufferGeometry();
const linePositions = new Float32Array(myHyperCube.lines.length * 3 * 2);

// For all the lines in the hypercube add pairs of points
for (let i = 0; i < myHyperCube.lines.length; i++) {
  // First line point vertices
  linePositions[i * 3 * 2] = projected3d[myHyperCube.lines[i][0]].x;
  linePositions[i * 3 * 2 + 1] = projected3d[myHyperCube.lines[i][0]].y;
  linePositions[i * 3 * 2 + 2] = projected3d[myHyperCube.lines[i][0]].z;

  // First line point vertices
  linePositions[i * 3 * 2 + 3] = projected3d[myHyperCube.lines[i][1]].x;
  linePositions[i * 3 * 2 + 4] = projected3d[myHyperCube.lines[i][1]].y;
  linePositions[i * 3 * 2 + 5] = projected3d[myHyperCube.lines[i][1]].z;
}

linesGeometry.setAttribute(
  'position',
  new THREE.BufferAttribute(linePositions, 3)
);

const lineMaterial = new THREE.LineBasicMaterial({
  color: 0xffffff,
  linewidth: 3,
});
const line = new THREE.LineSegments(linesGeometry, lineMaterial);

fourCubeGroup.add(line);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  50,
  sizes.width / sizes.height,
  0.1,
  100
);
// Controls
// const controls = new OrbitControls(camera, canvas);
// controls.enableDamping = true;

camera.position.set(0, -1.6, 3);
camera.lookAt(0, 0, 0);
scene.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.xr.enabled = true;
document.body.appendChild(VRButton.createButton(renderer));

renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();

fourCubeGroup.translateY(1.6);
fourCubeGroup.translateZ(-1.6);
renderer.setAnimationLoop(function () {
  const elapsedTime = clock.getElapsedTime();

  // Update Hypercube
  myHyperCube.transformUpdate(
    transform4D.scale,
    transform4D.angleXY,
    transform4D.angleXZ,
    (transform4D.angleXW += 0.004),
    transform4D.angleYZ,
    (transform4D.angleYW += 0.004),
    (transform4D.angleZW += 0.004),
    points,
    line
  );

  // Update controls
  // controls.update();

  // Render
  renderer.render(scene, camera);
});
